import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  UserOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  HomeOutlined
} from "@ant-design/icons";
import PropTypes from "prop-types";
import styles from "./layout.module.less";
import { Avatar, Breadcrumb, Dropdown, Badge } from "antd";
import { useSelector, shallowEqual, connect } from "react-redux";
import { toggleCollapsed, clearMenuList } from "@/store/reducers/appSlice";
import store2 from "store2";
import Logo from "@/assets/logo.svg";
import { USERINFO } from "@/config";
import { withAliveScope, useAliveController } from "react-activation";

const HeaderContent = (props) => {
  const { clear } = useAliveController();
  const navigate = useNavigate();
  const location = useLocation();
  const app = useSelector((state) => state.app, shallowEqual);
  const [user, setuser] = useState({});
  const [breadcrumbItems, setBreadcrumbItems] = useState([]);

  useEffect(() => {
    setuser(store2(USERINFO) || {});
  }, []);

  useEffect(() => {
    if (!app.menuList || app.menuList.length === 0) return;
    const paths = [];
    const findPath = (menus, parent) => {
      for (const menu of menus) {
        const chain = [...parent, menu];
        if (menu.path === location.pathname) {
          paths.push(chain);
          return true;
        }
        if (menu.routes && menu.routes.length > 0) {
          if (findPath(menu.routes, chain)) return true;
        }
      }
      return false;
    };
    findPath(app.menuList, []);
    const chain = paths[0] || [];
    setBreadcrumbItems(chain);
  }, [location.pathname, app.menuList]);

  const onClick = (e) => {
    console.log(e);
    if (e.key === "Logout") {
      store2.remove("userInfo");
      clear();
      props.clearMenuList(); // 使用正确的Redux action清除菜单列表
      navigate("/login", {
        replace: true
      });
    }
  };

  return (
    <div className={styles.header}>
      <div className={styles.headerInner}>
        <div className={styles.headerLeft}>
          {/* {app.collapsed ? (
            <MenuUnfoldOutlined
              style={{ fontSize: 20, color: "#1f2937", marginRight: 16 }}
              onClick={() =>
                props.toggleCollapsed({
                  collapsed: false
                })
              }
            />
          ) : (
            <MenuFoldOutlined
              style={{ fontSize: 20, color: "#1f2937", marginRight: 16 }}
              onClick={() =>
                props.toggleCollapsed({
                  collapsed: true
                })
              }
            />
          )} */}
          <Breadcrumb separator="/">
            <Breadcrumb.Item>
              <HomeOutlined />
            </Breadcrumb.Item>
            {breadcrumbItems.map((item) => (
              <Breadcrumb.Item key={item.path || item.name}>
                {item.name}
              </Breadcrumb.Item>
            ))}
          </Breadcrumb>
        </div>
        <div>
          <Dropdown
            menu={{
              items: [
                {
                  key: "Logout",
                  icon: <LogoutOutlined />,
                  label: "退出登录"
                }
              ],
              onClick: onClick
            }}
            trigger={["click"]}
          >
            <div
              className={styles.headerRight}
              onClick={(e) => e.preventDefault()}
            >
              <Avatar size={32} src={user.avatar} icon={<UserOutlined />} />
              <div className={styles.headerRightText}>
                欢迎您，{user.name || "Admin"}
              </div>
            </div>
          </Dropdown>
        </div>
      </div>
    </div>
  );
};

HeaderContent.propTypes = {
  toggleCollapsed: PropTypes.func
};

const mapStateToProps = (state) => state.app;
export default connect(mapStateToProps, { toggleCollapsed, clearMenuList })(
  HeaderContent
);
